import { Lang } from '../translations/lang'

export const boolToString = (value: boolean | undefined) =>
  value === true ? Lang.with : value === false ? Lang.without : ''
